import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalTemplateFillLine  {
    _originalTypeClassName = "zERP.BO.GeneralJournalTemplateFillLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalTemplateFillLine.translate = translateService;
}
this.ActualAccount = new Domain.Account();
this.IsDebit = false;
this.Credit = null;
this.Debit = null;
this.CreditAmountId = null;
this.DebitAmountId = null;
this.GroupId = null;
this.Index = null;
this.GeneralJournalTemplateFillLineKey = null;
this._key = this.GeneralJournalTemplateFillLineKey = 0; 
}

static translate: TranslateService;
_key: any;
IsDebit:any;
Credit:any;
Debit:any;
CreditAmountId:any;
DebitAmountId:any;
GroupId:any;
Index:any;
Definition:any;
ActualAccount:any;
private _GeneralJournalTemplateFillLineKey:any;
get GeneralJournalTemplateFillLineKey(): any {
    return this._GeneralJournalTemplateFillLineKey;
  }
set GeneralJournalTemplateFillLineKey(value: any) {
    this._GeneralJournalTemplateFillLineKey = value;
    this._key = value;
  }
static setDefinition = ($this, value) => {
var oldValue = $this.Definition;
$this.Definition = value;
if (value != null) {
}
}
static setActualAccount = ($this, value) => {
var oldValue = $this.ActualAccount;
$this.ActualAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalTemplateFillLineKey == null || $this.GeneralJournalTemplateFillLineKey == 0;
            }


}